// extracted by mini-css-extract-plugin
export default {"course_tags":"uV77dWumvf77vHWr33WP","courseTags":"uV77dWumvf77vHWr33WP","course_tag":"zitAegWwymCuO38cIx8o","courseTag":"zitAegWwymCuO38cIx8o","orange":"G7kRS4Srmw9MMwwy7dKc"};